import { getItemMaker } from "./tools";

const i = getItemMaker("shirts");
export const shirts = [
  i("Spore Tee", "EquipmentShirts16"),
  i("Black Tee"),
  i("Orange Tee", "EquipmentShirts1"),
  i("Green Tee"),
  i("Purple Tee"),
  i("Blue Tee"),
  i("Copper Platebody"),
  i("Planktop", "EquipmentShirts19"),
  i("Iron Platebody", "EquipmentShirts12"),
  i("Hide Shirt"),
  i("Tattered Cloth", "EquipmentShirts21"),
  i("Fur Shirt", "EquipmentShirts10"),
  i("MCR Tshirt", "EquipmentShirts17"),
  i("Amarok Bodyplate", "EquipmentShirts18"),
  i("Gold Platebody", "EquipmentShirts13"),
  i("Studded Hide", "EquipmentShirts5"),
  i("Feral Leathering", "EquipmentShirts23"),
  i("Furled Robes", "EquipmentShirts22"),
  i("Platinum Platbody", "EquipmentShirts14"),
  i("Dementia Body", "EquipmentShirts15"),
  i("Member Hoodie"),
  i("Efaunt Ribcage", "EquipmentShirts26"),
  i("Void Imperium Platebody", "EquipmentShirts27"),
  i("Damascus Plates"),
  i("Evergreen Wraps"),
  i("Elegantine Robes"),
  i("Chizoar Bodyplate"),
  i("Lustre Chestplate"),
  i("Diabolical Abdomen"),
  i("Trollish Garb", "EquipmentShirts34"),
  i("Magma Core Wavemaille"),
  i("Serrated Chest of the Divine"),
  i("Marbiglass Tunic"),
  i("Robe of the Gods"),
];
